import { createContext, useState } from "react";
import { EgnValid } from "../utils/EgnValidator";

export const WishValidatorContext = createContext();

export const WishValidatorProvider = ({ children }) => {
    const [wishErrors, setWishErrors] = useState([]);
    const [isSedGroupAuto, setIsSedGroupAuto] = useState({
        0: false
    });

    const validateSiblingEGN = (e, i, advantageCode, formData) => {
        if (formData.wishes[i][`${advantageCode}_EGN`] == '') {
            setWishErrors(state => ({
                ...state,
                [`${i}${advantageCode}`]: ''
            }));
            return true;
        }

        if (formData.wishes[i][`${advantageCode}_EGN`]
            && !EgnValid(formData.wishes[i][`${advantageCode}_EGN`])
            && formData.wishes[i][`${advantageCode}_IsEgn`] == true) {

            setWishErrors(state => ({
                ...state,
                [`${i}${advantageCode}`]: 'Невалидно ЕГН'
            }));

            return false;
        } else {
            setWishErrors(state => ({
                ...state,
                [`${i}${advantageCode}`]: ''
            }));

            return true;
        }
    }


    const removeError = (e, i, advCode) => {
        setWishErrors(state => ({
            ...state,
            [`${i}${advCode}`]: '',
        }))
    }



    return (
        <WishValidatorContext.Provider value={{ wishErrors, validateSiblingEGN, removeError, setIsSedGroupAuto, isSedGroupAuto }}>
            {children}
        </WishValidatorContext.Provider>
    )
}